var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", {
      staticClass: "error-msg",
      domProps: { innerHTML: _vm._s(_vm.errorMessage) }
    }),
    _c(
      "form",
      {
        attrs: { action: "#" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.onSubmit($event)
          }
        }
      },
      [
        _vm.brandRefer
          ? _c("h4", { staticStyle: { "text-align": "center" } }, [
              _vm._v("You have been invited by "),
              _c("strong", { staticClass: "green-text" }, [
                _vm._v(_vm._s(_vm.accessInvitaion.brand.name))
              ]),
              _vm._v(" to join CAPAS")
            ])
          : _vm._e(),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.brand.user_name,
              expression: "brand.user_name"
            }
          ],
          attrs: {
            type: "text",
            placeholder: "Full Name",
            autocomplete: "name",
            required: ""
          },
          domProps: { value: _vm.brand.user_name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.brand, "user_name", $event.target.value)
            }
          }
        }),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.brand.name,
              expression: "brand.name"
            }
          ],
          attrs: {
            type: "text",
            placeholder: "Brand Name",
            autocomplete: "name",
            required: "",
            disabled: _vm.brandRefer
          },
          domProps: { value: _vm.brand.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.brand, "name", $event.target.value)
            }
          }
        }),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.brand.email,
              expression: "brand.email"
            }
          ],
          attrs: {
            type: "email",
            placeholder: "Email",
            autocomplete: "email",
            required: "",
            disabled: _vm.brandRefer
          },
          domProps: { value: _vm.brand.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.brand, "email", $event.target.value)
            }
          }
        }),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.brand.iso_code,
                expression: "brand.iso_code"
              }
            ],
            staticClass: "country-code-field",
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.brand,
                  "iso_code",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          _vm._l(_vm.countries, function(country) {
            return _c(
              "option",
              { key: country.iso_code, domProps: { value: country.iso_code } },
              [
                _vm._v(
                  _vm._s(country.name) + "(" + _vm._s(country.isd_code) + ")"
                )
              ]
            )
          }),
          0
        ),
        _c("the-mask", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true, regex: /^\d{3} ?\d{3}-?\d{4}$/ },
              expression:
                "{ required: true, regex: /^\\d{3} ?\\d{3}-?\\d{4}$/ }"
            }
          ],
          staticClass: "phone-field",
          class: {
            input: true,
            "is-danger": _vm.errors.has("add-brand.mobile")
          },
          attrs: {
            mask: "### ###-####",
            type: "tel",
            autocomplete: "mobile",
            placeholder: "Mobile Number",
            name: "mobile"
          },
          model: {
            value: _vm.brand.mobile_number,
            callback: function($$v) {
              _vm.$set(_vm.brand, "mobile_number", $$v)
            },
            expression: "brand.mobile_number"
          }
        }),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.brand.password,
              expression: "brand.password"
            }
          ],
          attrs: {
            type: "password",
            placeholder: "Password",
            autocomplete: "current-password",
            required: ""
          },
          domProps: { value: _vm.brand.password },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.brand, "password", $event.target.value)
            }
          }
        }),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.otpConsent,
              expression: "otpConsent"
            }
          ],
          staticClass: "inline",
          attrs: { type: "checkbox", id: "alcoholic" },
          domProps: {
            checked: Array.isArray(_vm.otpConsent)
              ? _vm._i(_vm.otpConsent, null) > -1
              : _vm.otpConsent
          },
          on: {
            change: function($event) {
              var $$a = _vm.otpConsent,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.otpConsent = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.otpConsent = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.otpConsent = $$c
              }
            }
          }
        }),
        _c(
          "label",
          {
            staticStyle: { "margin-top": "8px", display: "inline" },
            attrs: { for: "alcoholic" }
          },
          [
            _vm._v(
              "Opt-in to receiving security authentication\n          for your private brand dashboard along with important messages regarding your account and login. By checking\n           this box you agree to receive these messages from CAPAS."
            )
          ]
        ),
        _c("input", {
          staticClass: "btn-lg-green",
          attrs: {
            disabled: _vm.busy || !_vm.otpConsent,
            type: "submit",
            value: "Continue"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }